export default __webpack_public_path__ + "static/media/edit.714c38d5.svg";